import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './../../locales/en/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  // Add other languages here
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
